import { Component, HostBinding, OnInit, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';

import { Group } from '../models/group.model';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-footer',
  template: require('./app-footer.component.html'),
  styles: [require('./app-footer.component.scss')],
  preserveWhitespaces: false,
})
export class AppFooterComponent implements OnInit {
  public group: Group;

  @HostBinding('attr.role') 
  private role = 'contentinfo';
  
  private destroyed: Subject<boolean> = new Subject<boolean>();

  constructor(
    private store: Store<AppState>,
    @Inject('$state') private $state,
    @Inject('LanguageService') public languageService,
  ) {};

  ngOnInit(): void {
    this.store.select((state: AppState): Group => state.group)
      .takeUntil(this.destroyed)
      .subscribe((group: Group): void => { this.group = group; });
  }

  ngOnDestroy() {
    this.destroyed.next(true);
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/app-footer/app-footer.component.ts